module.exports = __webpack_public_path__ + "static/img/img_p2_2_pic.63493c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p2_2_pic.png
// module id = eKi9
// module chunks = 1